/* eslint-disable react/jsx-props-no-spreading */
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import { TextField, InputLabel } from 'components/elements';
import { useFetchPersonalPronouns } from 'hooks';

function PronounSelect({ required, error, helperText, pronoun, onChange, showEmptyOption }) {
  const { data: pronounOptions } = useFetchPersonalPronouns(showEmptyOption);
  const { t } = useTranslation('labels');
  const [inputValue, setInputValue] = useState(pronoun);

  return (
    <Autocomplete
      style={{ width: '100%' }}
      id="pronoun-select"
      sx={{ width: 300 }}
      getOptionLabel={(option) => {
        if (!option) return '';
        if (typeof option === 'object') return option.label;
        const existingOption = pronounOptions.find((o) => o.key === option);
        return existingOption ? existingOption.label : option;
      }}
      filterOptions={(options) => {
        const value = inputValue?.trim()?.toLowerCase();
        if (!value) return options;
        const existingOption = options.find((o) => o.label.toLowerCase().includes(value));
        if (!existingOption) options.push({ id: options.length, key: value, label: value, isBlankOption: false, isNew: true });
        return options.sort((a, b) => a.id - b.id);
      }}
      options={pronounOptions}
      autoComplete
      includeInputInList
      filterSelectedOptions
      value={pronoun}
      popupIcon={null}
      autoHighlight
      onChange={(event, option) => {
        const value = option?.key ?? '';
        onChange(option?.isBlankOption ? '' : value);
      }}
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      renderInput={(params) => <TextField error={error} helperText={helperText} label={<InputLabel text={t('personal_pronoun')} required={required} />} {...params} />}
      renderOption={(props, option) => (
        <Grid container alignItems="center">
          <Grid item xs>
            <li {...props}>
              <span style={{ minHeight: '25px' }}> {`${option.label}${option.isNew ? ` (${t('new')})` : ''}`} </span>
            </li>
          </Grid>
        </Grid>
      )}
    />
  );
}
PronounSelect.propTypes = {
  error: PropTypes.bool,
  required: PropTypes.bool,
  helperText: PropTypes.string,
  showEmptyOption: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  pronoun: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.any)]),
};

PronounSelect.defaultProps = {
  pronoun: '',
  error: false,
  helperText: '',
  required: false,
  showEmptyOption: true,
};

export default PronounSelect;
